module.exports = __webpack_public_path__ + "img/bg.8703f806.png";